import { useState, useEffect } from 'react'

import { getProvincesAPI } from '../services/address'
import { getTrainingListLevelAPI } from '../services/certificate'

function UseLevel() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListLevelAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.t_level }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseLevel
